"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keymirror = require("keymirror");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actionTypes = (0, _keymirror2.default)({
  AUTHENTICATE_FAILURE: null,
  AUTHENTICATED: null,
  AUTHENTICATING: null,
  LOGOUT: null,
  SET_SNACKBAR_MESSAGE: null,
  SET_USER: null,
  SET_OFFER_PASSWORD: null
});

exports.default = actionTypes;